import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEventbriteComponent } from './simple-icons-eventbrite.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEventbriteComponent ],
    exports:      [ SimpleIconsEventbriteComponent ],
    bootstrap:    []
})
export class SimpleIconsEventbriteModule {}
